/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ChevronLeft = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.71512 12.2497L15.1999 6.76501L14.1393 5.70435L8.65446 11.189L7.69993 12.2497L8.65446 13.3103L14.1394 18.7951L15.2001 17.7345L9.71512 12.2497Z"
                        fill={color}
                    />
                </svg>
        );
    };
